import React from "react";
import ReactDOM from "react-dom";
import Homepage from "./Homepage";
import "./index.css";
import "./fonts/Quicksand/Quicksand-Regular.ttf";

ReactDOM.render(
  <React.StrictMode>
    <Homepage />
  </React.StrictMode>,
  document.getElementById("root")
);
